<template>
  <van-popup v-model="visible" position="bottom">
    <!-- 《关于客户个人信息收集、使用规则的公告》 -->
    <div class="agreement-wrapper" v-if="type === 1">
      <p class="title">关于客户个人信息收集、使用规则的公告</p>
      <p>尊敬的客户：</p>
      <p>根据《中华人民共和国反恐怖主义法》、《全国人民代表大会常务委员会关于加强网络信息保护的决定》、《电信和互联网用户个人信息保护规定》（工业和信息化部令第24号）和《电话用户真实身份信息登记规定》（工业和信息化部令第25号）等国家法律法规的要求，客户在中国联合网络通信有限公司各类营业网点（含自有营业厅、手机营业厅、网上营业厅、授权合作代理商等）办理固定电话、移动电话（含无线上网卡）入网、过户以及需要出示客户证件的有关业务时，客户应配合出示有效证件原件并进行查验、登记，登记信息包括姓名、证件类型、号码及地址等。同时，为更好地提供服务，需要客户提供如联系人、联系电话、通信地址、电子邮箱等信息。客户本人持有效证件可通过自有营业厅查询和/或更正本人信息，或登录手机营业厅查询本人信息。</p>
      <p>如客户拒绝依法提供个人有效证件及真实信息，我公司有权不提供服务或终止服务。</p>
      <p>为向客户提供优质、个性化的服务，包括但不限于提供通信服务、保障通信服务安全、改善服务质量、推介个性化产品等，我公司将遵循合法、正当、必要的原则，按照法律法规规定和/或协议约定使用留存客户个人信息，并妥善保管，严格保密，依法保护客户个人信息，非因下列事由，不对外泄露客户个人信息：</p>
      <p>(a)事先获得客户的明确授权；</p>
      <p>(b)根据有关的法律法规要求；</p>
      <p>(c)按照相关司法机关和/或政府主管部门的要求；</p>
      <p>(d)为维护社会公众的利益所必需且适当；</p>
      <p>(e)为维护我公司或客户的合法权益所必需且适当。</p>
    </div>
    <!-- 《中国联通儿童个人信息保护政策及监护人须知》 -->
    <div class="agreement-wrapper" v-if="type === 2">
      <p>中国联通（以下简称“我们”）致力于保护使用我们产品或服务的儿童的个人信息。在《中国联通用户隐私政策》的基础上，我们希望通过《中国联通儿童个人信息保护政策及监护人须知》（以下简称“本须知”）向监护人（以下亦称“您”）和您监护的儿童（指未满14周岁的未成年人，以下亦称“您的孩子”）说明我们在收集和使用儿童个人信息时对应的处理规则等相关事宜。请在使用我们的产品或服务前务必仔细阅读并透彻理解本须知，特别是以粗体标识的条款应重点阅读，在确认充分理解并同意全部条款后再开始使用或允许您的孩子使用。</p>
      <p>本须知为在《中国联通用户隐私政策》基础上制定的特别规则，除另有约定外，本须知所用术语和缩略词与《中国联通用户隐私政策》中的术语和缩略词具有相同的涵义；与《中国联通用户隐私政策》如有不一致之处，以本须知为准；本须知未载明之处，则参照适用《中国联通用户隐私政策》。为了维护儿童的合法权益，儿童应当在其监护人的指导下使用我们的服务。</p>
      <p>监护人特别说明：</p>
      <p>您的理解和配合对我们保护您孩子的个人信息和隐私安全非常必要，为了维护您孩子的合法权益，我们希望您可以协助我们，确保您的孩子在您的同意和指导下使用我们的产品或服务和向我们提交个人信息。我们将根据本须知采取特殊措施保护我们获得的您孩子的个人信息。如果您不同意本须知的内容，请您要求您的孩子立即停止访问/使用我们的产品或服务。儿童特别说明：</p>
      <p>如果您未满14周岁，请务必通知您的监护人共同阅读本须知，并在您使用我们的产品或服务、提交个人信息之前，寻求您的监护人的同意和指导。</p>
      <p>一、如何收集和使用儿童信息</p>
      <p>（一）在儿童使用我们的产品或服务过程中，我们会严格履行法律法规规定的儿童个人信息保护义务与责任，遵循正当必要、知情同意、目的明确、安全保障、依法利用的原则，在征得监护人的同意后收集和使用儿童个人信息。具体请查阅《中国联通用户隐私政策》“我们如何收集和使用您的个人信息”一节，详细了解我们收集和使用的儿童个人信息。</p>
      <p>（二）我们也会通过Cookie等同类技术自动收集您或您孩子的个人信息，具体请您查阅《中国联通用户隐私政策》“我们如何使用Cookie和同类技术”部分进行详细了解。</p>
      <p>（三）我们提供的与儿童有关的服务是不断发展的。如我们需要超出上述收集范围收集您或您监护的儿童的个人信息，我们将再次告知您，并征得您的同意。</p>
      <p>（四）根据相关法律法规规定，以下情形中收集儿童的信息无需征得儿童监护人的授权同意：</p>
      <p>1.为订立、履行与您或您的孩子的合同所必需；</p>
      <p>2.为履行法定职责或者法定义务所必需；</p>
      <p>3.为应对突发公共卫生事件，或者紧急情况下为保护儿童的生命健康和财产安全所必需；</p>
      <p>4.在合理的范围内处理您自行公开或者其他已经合法公开的个人信息；</p>
      <p>5.与国家安全、国防安全有关的；</p>
      <p>6.与公共安全、重大公共利益有关的；</p>
      <p>7.与犯罪侦查、起诉、审判和判决执行等有关的；</p>
      <p>8.用于维护所提供的产品或服务的安全稳定运行所必需，例如发现、处置产品或服务的故障；</p>
      <p>9.法律法规及监管政策规定的其他情形。</p>
      <p>请您理解，您可以选择是否填写或向我们提供特定的信息，但您如果不填写或提供某些特定的信息，将可能导致我们的产品或服务无法正常运行，或者无法达到我们拟达到的服务效果，您和您监护的儿童可能无法正常使用我们的产品、服务或相关的具体业务功能。</p>
      <p>二、如何共享、转移和公开披露儿童信息</p>
      <p>我们承诺对儿童个人信息进行严格保密，我们遵照法律法规的规定，严格限制共享、转移、披露儿童个人信息的情形，仅在《中国联通用户隐私政策》约定和您明确授权同意的情况下对外提供儿童信息。</p>
      <p>除了《中国联通用户隐私政策》“我们如何共享、转移、公开披露您的个人信息”部分所述的内容外，对于儿童个人信息，我们还将会采取如下措施来保护儿童个人信息在共享、转移和公开披露过程中的安全：</p>
      <p>（一）如果为了本须知所述目的而需要将儿童信息共享至第三方，我们会对受委托方及委托行为等进行安全评估，签署委托协议，要求受委托方的处理行为不得超出我们的授权范围。我们将评估该第三方收集儿童个人信息的合法性、正当性、必要性，并采用加密、匿名化、去标识化处理等手段保障您和儿童的信息安全。</p>
      <p>（二）我们将要求第三方对儿童个人信息采取保护措施，并且严格遵守相关法律法规与监管要求。我们会要求接收儿童个人信息的第三方遵守严格的保密义务及采取有效的保密措施，禁止其将这些儿童个人信息用于未经儿童及其监护人授权的用途，并要求受托公司依法履行以下义务：</p>
      <p>1.按照法律、行政法规的规定和我们的要求处理儿童个人信息；</p>
      <p>2.协助我们回应儿童监护人提出的申请；</p>
      <p>3.采取措施保障信息安全，并在发生儿童个人信息泄露安全事件时，及时向我们反馈；</p>
      <p>4.委托关系解除时及时删除儿童个人信息；</p>
      <p>5.不得转委托；</p>
      <p>6.其他依法应当履行的儿童个人信息保护义务。</p>
      <p>（三）我们会按照法律法规的要求征得您的同意，或确认第三方已经征得您同意。</p>
      <p>三、如何储存儿童个人信息</p>
      <p>（一）我们在中华人民共和国境内收集和产生的儿童个人信息，将存储在中国境内。</p>
      <p>（二）我们会采取合理可行的措施，尽力避免收集和处理无关的儿童的个人信息。我们只会在达成本须知所述目的所需的期限内保留儿童的个人信息，除非法律有强制的留存要求。关于我们如何确定儿童个人信息存储期限请参见《中国联通用户隐私政策》“我们如何保护您的个人信息”。如我们终止服务或运营，我们将及时停止继续收集儿童个人信息的活动，同时会遵守相关法律法规要求提前向监护人通知，并在终止服务或运营后对儿童的个人信息进行删除或匿名化处理，但法律法规或监管部门另有规定的除外。</p>
      <p>四、如何保护儿童信息</p>
      <p>我们非常重视儿童的隐私安全，并采取一切合理可行的措施，保护儿童个人信息：</p>
      <p>（一）我们会严格控制儿童个人信息的访问权限，对可能接触到儿童个人信息的工作人员采取最小够用授权原则，并采取技术措施对工作人员处理儿童个人信息的行为进行记录和管控，避免违法复制、下载儿童个人信息。</p>
      <p>（二）我们会定期组织内部相关人员进行培训，使其掌握岗位职责和应急处置策略和规程。在不幸发生儿童个人信息安全事件后，我们将按照法律法规的要求，及时向儿童及其监护人告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、儿童及其监护人可自主防范和降低风险的建议、对儿童及其监护人的补救措施等。我们将及时将事件相关情况以App推送通知、发送邮件/短消息等方式告知儿童及其监护人。难以逐一告知时，我们会采取合理、有效的方式发布相关警示信息。同时，我们还将按照监管部门要求，主动上报儿童个人信息安全事件的处置情况。若儿童及其监护人的合法权益受损，我们将承担相应的法律责任。</p>
      <p>（三）如您希望了解更多，请查阅《中国联通用户隐私政策》“我们如何保护您的个人信息”章节，详细了解我们如何采取了哪些措施保护儿童个人信息。</p>
      <p>五、如何管理儿童信息</p>
      <p>（一）为了您或您的孩子在使用我们的产品或服务期间可以更加便捷地访问和管理您孩子的个人信息，同时保障删除个人信息的权利，您和您的孩子可以按照《中国联通用户隐私政策》中的“您的权利”章节指引进行操作。</p>
      <p>（二）如存在以下情况，您和您监护的儿童可以请求我们删除收集、使用和处理的儿童个人信息。我们会在完成身份验证后，及时采取措施予以删除。</p>
      <p>1.若我们违反法律、行政法规的规定或者双方的约定收集、存储、使用、转移、披露儿童个人信息；</p>
      <p>2.若我们超出目的范围或者必要期限收集、存储、使用、转移、披露儿童个人信息；</p>
      <p>3.儿童监护人撤回同意；</p>
      <p>4.儿童或者其监护人通过注销等方式终止使用产品或者服务的。</p>
      <p>但请注意，若您和被监护儿童要求我们删除特定儿童个人信息，可能导致该儿童无法继续使用我们的产品和服务或产品和服务中的某些具体业务功能。</p>
      <p>如您发现在未事先征得您同意的情况下收集了您监护儿童的个人信息，请及时联系我们，我们会设法尽快删除相关数据。</p>
      <p>六、适用</p>
      <p>绝大多数情形下我们无法识别且不会判断收集和处理的个人信息是否属于儿童个人信息，我们将按照《中国联通用户隐私政策》收集和处理用户的个人信息。</p>
      <p>七、本须知的修订</p>
      <p>基于为给您提供更好的服务的目的，我们可能会根据我们的产品或服务的更新情况及法律法规的相关要求适时修改本须知的条款，该等修改构成本须知的一部分，我们会在专门页面上展示最新修改版本。由于我们的用户较多，对于重大变更，我们还会提供更为显著的通知（包括在中国联通APP、中国联通官方网站发布公告的方式来通知您），具体详见《中国联通用户隐私政策》“本隐私政策如何更新”的规定。</p>
      <p>八、如何联系我们</p>
      <p>公司名称：中国联合网络通信有限公司</p>
      <p>注册地址：北京市西城区金融大街21号联通大厦</p>
      <p>联系电话：10010客服热线</p>
      <p>相关负责人邮箱：hqs-yhys@chinaunicom.cn</p>
      <p>    网站：http://www.10010.com</p>
      <p>如您对本须知或您和您孩子的个人信息的相关事宜有任何问题、投诉、意见或建议，您可前往中国联通当地营业厅、拨打10010客服热线、访问http://www.10010.com网上营业厅、使用中国联通APP等多种方式与我们联系。一般情况下，我们将在十五个工作日内回复。</p>
    </div>
    <!-- 《中国联通客户入网服务协议》 -->
    <div class="agreement-wrapper" v-if="type === 3">
      <p class="title">中国联通客户入网服务协议</p>
      <p>中国联通客户入网服务协议</p>
      <p>乙方：中国联合网络通信有限公司江苏分公司 </p>
      
      <p>根据《中华人民共和国民法典》、《中华人民共和国数据安全法》、《中华人民共和国个人信息保护法》、《中华人民共和国电信条例》等有关法律法规的规定，甲乙双方在平等、自愿、公平、诚信的基础上，基于对乙方通信服务的了解和需求，甲方自愿申请成为乙方客户，并达成协议如下： </p>
      <p>第一条    入网要求及业务办理 </p>
      <p>（一）甲方办理入网、变更手续时，应提交以下登记资料： </p>
      <p>1、个人客户：提供个人有效身份证件原件，委托他人办理的应同时提交本人及代理人有效身份证件原件及授权委托书。利用个人临时身份证件原件办理的，须同时提供公安部门出具的身份证领取凭证、身份信息辅助证件（驾照、医保卡或户口本等），不得委托他人办理。 </p>
      <p>2、单位客户：提供单位有效证件原件（或加盖公章的单位有效证件复印件）、经办人有效身份证件原件、加盖公章的单位授权书等。单位客户办理移动电话（含无线上网卡）业务时，须同时提供实际使用人有效身份证件。 </p>
      <p>3、甲方户籍所在地（以有效身份证件的住址为准）或法定住所地（单位有效证件上单位注册地）不在本地的，应该按照乙方的要求办理相应的担保手续。 </p>
      <p>（二）甲方应使用国家给予入网许可标志的终端设备，终端设备应具备支持所选服务的相应功能，如无法支持所选服务，甲方应自行承担后果，并向乙方全额支付其所选服务的全部费用。 </p>
      <p>（三）甲方欲将业务号码过户时，应先交清所有费用，过户时须由双方持有效身份证件原件办理。如有特殊情况，甲方可委托他人办理，但应同时提交本人及代理人有效身份证件原件及授权委托书。 </p>
      <p>（四）在甲方通过过户成为新机主的情形下，如因原机主未亲自到场办理过户而导致原机主就此提出异议，甲方应无条件放弃因过户产生的全部权益，并承担由此对原机主及对乙方造成的一切损失。过户代理人对此承担连带责任。 </p>
      <p>（五）甲方采用担保人方式入网的，办理过户业务时，甲方须提交担保人出具的书面文件，说明担保人同意继续担保或要求终止担保。新机主应符合本协议第一条第（一）款的条件。 </p>
      <p>（六）甲方本人未到场，由代理人、经办人办理各类业务的，甲方应承担由此产生的责任与义务；代理人、经办人承担连带责任。 </p>
      <p>（七）甲方欲将业务号码办理销户，应先交清所有费用，销户时须持有效身份证件原件办理。如甲方在销户后90日内未办理销户复装业务，则乙方可在90日后重新启用该业务号码。 </p>
       
      <p>第二条    费用标准和费用交纳 </p>
      <p>（一）乙方应在国家电信资费主管部门允许的范围内设定资费标准、向客户明码标价、公告交费期限信息；甲方应在乙方明示的期限内足额交纳各项通信费用。 </p>
      <p>（二）甲方使用乙方提供的资费套餐方案，套餐有效期为一年（双方特殊约定的除外）。套餐到期后，双方如无异议，有效期逐年自动顺延。如无特殊约定，甲方在有效期内或到期后可更换套餐。 </p>
      <p>（三）如遇国家统一调整通信费用标准，则按国家统一规定执行。如遇乙方发布、调整资费，自乙方公告确定的生效日起执行新的资费标准。在乙方公告确定的生效日前，甲方未提出异议的视为同意，协议继续履行；甲方提出异议且未能与乙方达成一致的，甲方向乙方结清全部未付款项后本协议自动终止。 </p>
      <p>（四）若甲方为后付费用户，每月1日—25日为支付上月费用的交费期限。甲方应按时交纳通信费用。甲方未在约定期限内足额交纳通信费用的，乙方每日加收所欠费用的３‰作为违约金，并有权暂停甲方服务；甲方交清欠费和违约金后，除甲方明确提出不开通或已销号外，乙方应在24小时内恢复甲方服务。对前述情形，乙方将保留追缴欠费、违约金及向征信机构提供用户欠费信息的权利，也可用通知单、委托第三方等形式追缴欠费。 </p>
      <p>（五）若甲方为预付费用户，则必须保证账户上有充足的款项。如甲方账户满足消费条件的余额不足，乙方有权限制或停止向甲方提供服务，且乙方可不再另行通知。 </p>
      <p>（六）甲方定制第三方增值业务或其它收费业务，乙方可以代第三方向甲方收取信息费、功能费等，甲方使用第三方提供的增值业务或其它收费业务由第三方制定收费标准并公布。 </p>
      <p>（七）甲方如需开通国际业务、港澳台业务，应按乙方规定交纳相应费用。 </p>
      <p>（八）甲方不应以不知晓终端产生网络流量的原因（例如终端软件自动升级）为由，拒绝支付或要求减免相应费用。 </p>
      <p>（九）国内语音计费单位为一分钟，不足一分钟按一分钟计算；如产品另有约定，以产品约定为准。 </p>
      
      <p>第三条    客户权益 </p>
      <p>（一）网络服务 </p>
      <p>1、乙方在现有技术条件下的4G及以上网络覆盖范围内向甲方提供通信服务，并符合国家规定的通信质量标准。甲方理解并认可在现有技术水平、建筑物遮挡、基站周边地形地貌、人为阻拦布置基站等因素影响下，仍然不可避免地存在信号弱或无信号覆盖等情况。</p> 
      <p>（二）客户服务 </p>
      <p>1、为向甲方提供更好的服务，乙方将通过营业网点、网站、APP、短信、彩信、5G消息、电话、电子邮件、信函、即时通信、公开媒体等方式向甲方发送社会公益、通信服务、业务使用、客户权益、诈骗风险警示、市场活动、优惠促销等信息及进行沟通互动。乙方还应向甲方免费提供通话所在地（仅限大陆地区，不含港澳台）火警119、匪警110、医疗急救120、交通事故报警122等公益性电信服务。 </p>
      <p>2、乙方向甲方提供需要甲方支付月功能费的服务项目时，应征得甲方同意；乙方开通服务项目让甲方进行体验时，不收取体验服务项目月功能费。 </p>
      <p>3、对于甲方通信服务开通/关闭申请，乙方应在承诺的时限内操作完成（双方另有约定的除外）。乙方超过时限未及时开通/关闭的，应减免超时限后甲方由此产生的通信费用。 </p>
      <p>4、甲方个人信息是指以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。乙方严格按照《中华人民共和国个人信息保护法》等法律法规的要求，在向甲方提供服务过程中遵循合法、正当、必要和诚信原则，处理甲方个人信息。本协议解除或终止后，乙方不再收集甲方个人信息，并将按照相关法律法规规定对本协议存续期间收集的甲方个人信息进行处理。 </p>
      <p>在儿童（指未满14周岁的未成年人）使用我们的产品或服务过程中，我们会严格履行法律法规规定的儿童个人信息保护义务与责任，遵循正当必要、知情同意、目的明确、安全保障、依法利用的原则，在征得监护人的同意后收集和使用儿童个人信息。 </p>
      <p>5、甲方理解并同意，乙方可以通过业务受理系统登记、纸质返档，通过网络接收、读取并记录等方式，以提供服务为目的，在业务活动中收集、使用甲方提供的和甲方使用服务过程中形成的个人信息。乙方可以为向甲方提供服务、改进服务质量、改进和完善服务、提供个性化或定制化产品与服务、评估服务中的促销与推广活动效果、确保产品服务安全性、邀请甲乙方参与产品服务调查、软件认证或升级等目的使用甲方个人信息；乙方有权依法对包含甲方在内的整体用户数据进行分析并加以利用，以便于为甲方提供更好服务。 </p>
      <p>6、甲方理解并同意，乙方的某些服务将由其授权合作伙伴或关联公司提供。乙方可能会与其授权合作伙伴或关联公司共享甲方的某些个人信息，以提供必要的客户服务。乙方确认将依照合法、正当、必要、诚信原则，仅出于在能够实现业务目的最小范围内共享甲方必要的个人信息，且受本协议约定的处理目的、处理方式、信息种类的约束。乙方会与其签署相应保密协议，要求其按照乙方要求及相关保密和安全措施处理个人信息所声明目的的约束。乙方授权合作伙伴或关联公司无权将共享的个人信息用于任何其他用途。如相关法律法规、监管政策要求或乙方为维护甲方权益认为确有必要时，乙方亦会在将信息提供给授权合作伙伴或关联公司前征得甲方的单独同意。授权合作伙伴或关联公司如要改变个人信息的处理目的和处理方式，将再次征求甲方的授权同意。 </p>
      <p>7、甲方本人持有效证件可通过自有营业厅或乙方指定的其他渠道，对其个人信息进行查询、更正。 </p>
      <p>8、乙方依法保证甲方的信息资料安全、通信自由和通信秘密。但以下情形不应视为乙方违反个人信息保护义务：（1）因追缴欠费需要，向第三方机构和征信机构提供用户个人相应信息及欠费信息的；（2）为向甲方提供更好的服务，乙方通过营业网点、网站、APP、短信、彩信、5G消息、电话、电子邮件、信函、即时通信、公开媒体等方式向甲方发送社会公益、通信服务、业务使用、客户权益、诈骗风险警示、市场活动、优惠促销等信息及进行沟通互动的；（3）为订立、履行与您的合同所必需；（4）为履行法定职责或者法定义务所必需；（5）为应对突发公共卫生事件，或者紧急情况下为保护您的生命健康和财产安全所必需；（6）在合理的范围内处理您自行公开或者其他已经合法公开的个人信息；（7）与国家安全、国防安全有关的；（8）与公共安全、重大公共利益有关的；（9）与犯罪侦查、起诉、审判和判决执行等有关的；（10）用于维护所提供的产品或服务的安全稳定运行所必需，例如发现、处置产品或服务的故障；（11）法律法规及监管政策规定的其他情形。 </p>
      <p>9、乙方非常重视用户的隐私和个人信息保护，并会尽全力保护用户的个人信息安全可靠。关于乙方如何收集、存储、使用、披露和保护甲方的个人信息，详见乙方不时更新、修订并公布的《中国联通用户隐私政策》，网址为www.10010.com。 </p>
        
      <p>第四条    风险与责任 </p>
      <p>（一）甲方应保证入网、变更登记资料真实有效、准确完整，并有义务配合乙方对登记资料进行查验。甲方登记资料如有变更，应主动办理变更手续。甲方不得出租、二次转售、倒卖名下持有的通信卡，如需将通信卡转让给他人使用，应在乙方营业厅办理过户。因甲方提供的客户资料不详、不实或变更后未及时通知乙方等原因，使乙方无法向甲方提供服务或甲方无法享受到乙方提供的相关服务，乙方无需向甲方承担任何责任。如乙方发现因甲方登记资料失实或者甲方未配合及时更正，或乙方发现甲方业务号码存在违法使用、违规外呼、呼叫频次异常、超约定用途使用、违规或违约转让、转租、转售、业务号码被公安机关通报、该号码因上述问题被投诉较多等情况的，乙方有权暂停、终止甲方服务，且乙方无需向甲方承担任何责任。 </p>
      <p>（二）甲方应妥善保管自己的用户号码、通信卡、终端、宽带账号，若发现丢失或被盗用，可及时拨打客户服务电话或到乙方营业网点办理暂时停机或修改账号密码手续；并可向公安机关报案，乙方应配合公安机关调查，但乙方不承担上述情形对甲方所造成的后果；如甲方将名下号码交予他人使用，因此引起的义务与责任仍由甲方承担。 </p>
      <p>（三）甲方应妥善管理其服务密码、短信验证码。服务密码、短信验证码是甲方办理业务的重要凭证，甲方入网后应立即修改初始服务密码。凡使用服务密码、短信验证码定制、变更或终止业务的行为均被视为甲方或甲方授权的行为，因此引起的义务与责任均由甲方承担。 </p>
      <p>（四）乙方按照现有技术标准为甲方提供通信服务，但乙方无法控制第三方利用各种手段从事违法行为等情况的发生，如因第三方的恶意行为造成甲方的损失，乙方对此将不承担相关责任。 </p>
      <p>（五）甲方使用固网及宽带业务时，未经有关部门批准许可，不得自行更改其使用性质，不得开设各类服务站点，不得利用计算机互联网络进行任何经营性服务活动，否则乙方有权停止服务，依法追缴各项费用和违约金，并不承担任何责任。如甲方出现上行带宽违规聚合(PCDN)等上述违约行为，应按照IDC带宽标准资费追偿甲方合同期限内的违约责任。 </p>
      <p>PCDN违规聚合是指企业及个人客户租用电信运营商大量宽带(含家庭宽带产品、商务宽带产品、商务专线产品)，擅自改变产品用途，将自用的上行带宽聚合形成大带宽进行流量经营。 </p>
      <p>（六）若非双方另行约定，乙方提供的宽带接入线路最多限定4个终端上网使用，未经乙方书面同意，甲方不得私自组网连接其他终端设备。 </p>
      <p>（七）甲方退网时，甲方租赁或乙方免费提供给甲方使用的终端设备，应归还乙方或按照甲乙双方相关约定处理。 </p>
      <p>（八）甲方在欠费情况下，乙方有权拒绝为甲方开办其他业务（含移网、固网、宽带等所有业务），直至甲方补交全部欠费及违约金。 </p>
      <p>（九）乙方在受理业务（服务）后，对于因任意一方客观原因不具备开通条件的，本协议自动终止，乙方退还甲方已交纳费用，甲方退还乙方提前领取的终端设备，双方互不承担违约责任。 </p>
      <p>（十）在固定电话开通并正常使用前（含新装、移机、改号等），甲方不能将已选中号码通知他人或进行宣传，否则由此所造成的后果及损失，由甲方自行承担。 </p>
      <p>（十一）甲方所办理的数据业务上下行速率标称值仅为乙方提供的数据业务上下行速率最高值，乙方不能保证在任何情况下均能达到标称值，甲方对此表示知悉并认可。 </p>
      <p>（十二）按照公平使用原则，乙方将对甲方的移动数据流量进行降速或封顶限制。甲方每月的移动数据流量达到降速条件时，乙方可对甲方当月的上网服务降速，次月自动恢复；甲方每月的移动数据流量达到或超出流量封顶额度时，乙方可暂停甲方当月的上网服务，次月自动恢复。 </p>
      <p>（十三）甲方未付的通信费用达到信用额度时（信用额度是指用户可以用于透支消费的最高通信费用额度），应及时补充交纳通信费用；当甲方未付的通信费用超过信用额度时，乙方有权暂停甲方网络服务（超过信用额度停机不受约定交费期限的限制）。 </p>
      <p>（十四）甲方发布违法信息、违反公序良俗内容的信息，或未经接收客户同意大量发布商业广告等其他骚扰垃圾信息、拨打骚扰电话等不当行为，以及利用乙方提供的服务从事电信网络诈骗等违法犯罪活动的，乙方有权依据行业主管部门、有关行政机关的指令、客户举报或投诉、乙方相关系统检测，以及乙方制定的为保障公众利益的规范，要求甲方重新进行身份认证，或关闭甲方信息发送短信、彩信、语音、流量等通信功能，或暂停直至终止服务，或限制甲方办理新入网等业务，由此造成的后果由甲方承担。 </p>
      <p>（十五）甲方承诺不冒用或伪造身份证照办理乙方的号卡等业务，甲方个人身份信息以及办理的号卡不租借、不贩买给他人。甲方制作、发布、传播违法违规信息、违反公序良俗内容的信息，或未经接收客户同意大量发布商业广告等其他骚扰信息、拨打诈骗、骚扰电话等不当行为，以及利用乙方提供的服务从事违法犯罪活动的，乙方有权依据行业主管部门、有关行政机关的指令、客户举报或投诉，以及乙方制定的为保障公众利益的规范，关闭甲方信息发送功能，或暂停直至终止服务，由此造成的后果由甲方承担。 </p>
      <p>如出现任何违反上述承诺或因此引发的社会群众投诉和违法行为，甲方将自愿承担所有责任，同意乙方关停号码并不再复机（包括但不限于在不通知的情况下关停业务），并将甲方身份信息纳入“诈骗、骚扰电话黑名单”中，在一定时间段内限制其办理乙方各项业务。 </p>
      <p>（十六）因甲方原因造成的通信卡密码丢失、锁卡或被他人获取造成的损失，乙方不承担责任，甲方不能以此为由拒绝按本协议约定支付通信费用。 </p>
      <p>（十七）乙方可能重新启用并销售部分其他客户曾使用过的移动电话号码。原使用该号码的客户（以下简称为“原机主”）如将该号码留作第三方业务的联系电话或者绑定第三方业务，且原机主未在注销前予以变更或解除绑定，该号码可能会收到第三方发给原机主的通知，或者因第三方的限制无法在解除绑定前完成甲方新客户认证绑定。甲方需自行至第三方办理解除绑定等，乙方在合理限度内提供配合。 </p>
      <p>（十八）携号转网相关约定： </p>
      <p>1、甲方有权选择并依据《携号转网服务管理规定暂行办法》（以下简称“《携号转网管理办法》”）规定申请办理携号转网服务。 </p>
      <p>2、办理携号转网过程中，乙方需将必要的甲方个人信息提供给携号转网集中业务管理系统，用于比对携入方和携出方登记的证件信息是否一致。 </p>
      <p>3、甲方申请携号转网服务的号码应同时满足以下条件：（1）已在携出方办理个人真实身份信息登记；（2）号码处于正常使用状态（非挂失、停机等）；（3）与携出方结清申请携号转网号码的已出账电信费用，如有未出账的电信费用（包括但不限于国际漫游费用等），与携出方已约定缴费时间和方式；（4）与携出方无在网约定期限限制的协议，或已解除在网期限限制；（5）申请携号转网的号码距离上次携转时间已满120日（自然日）。 </p>
      <p>4、因技术与设备等差异，甲方携号转网成功后可能需要自行更换手机。 </p>
      <p>5、如甲方使用充值卡在原有卡上预存费用，在携号转网成功后将不能继续使用原有卡上剩余费用。 </p>
      <p>6、如甲方从其他网络携号转入乙方网络，甲方在原网络享受的积分、信用度、VIP级别及各种优惠将不能在乙方网络继续使用。 </p>
      <p>7、如甲方办理携号转网，可能会在启用新卡的时间点和网络切换期间出现短时间的通信异常。 </p>
      <p>8、甲方可在办理携号转网业务当日（乙方营业时间内）撤销携号转网业务申请。 </p>
      <p>9、甲方在携号转网成功后仍需与携出方结清通信费用。 </p>
      <p>10、如甲方从其他网络携号转入乙方网络，携出方和乙方收到携号转网成功生效结果告知后，网络切换完成。网络切换完成后，甲方在乙方办理的新移动电话卡激活启用，由乙方为甲方提供电信服务。 </p>
      <p>11、本协议未约定的携号转网事项，双方按照《携号转网服务管理规定》、《携号转网管理办法》规定及双方就携号转网业务签订的具体文件（包括但不限于补充协议、业务受理单等）约定执行。本协议关于携号转网业务的约定如与《携号转网服务管理规定》、《携号转网管理办法》规定及双方携号转网具体文件约定发生冲突，以《携号转网服务管理规定》、《携号转网管理办法》和双方携号转网具体文件内容为准。 </p>
      
      <p>第五条    违约责任 </p>
      <p>（一）一方违约给对方造成损失的，应当依法承担赔偿责任，但违约方应承担的赔偿损失的责任范围不包括守约方未实现的预期利润或利益、商业信誉的损失、丢失的数据本身及因数据丢失引起的损失、守约方对第三方的责任及其他间接损失。</p> 
      <p>（二）因不可抗力导致本协议部分或全部不能履行的，双方可部分或全部免除责任。 </p>
        
      <p>第六条    协议的变更与解除 </p>
      <p>（一）乙方在本协议外以公告、使用手册、资费单页等书面形式公开做出的服务承诺，甲方办理各类业务所签署的表单、业务协议、须知等经甲方签署后均成为本协议的补充协议；与本协议冲突部分以补充协议为准，补充协议中未约定部分以本协议为准。 </p>
      <p>（二）甲方要求终止服务（双方另有约定的除外）申请办理拆机或销户的，若甲方为后付费且申请办理拆机或销户时当月的应付费用未出账，或甲方为预付费但预存费用可能不足以支付当月应付费用的，则应按照乙方要求预存一定数额的通信费，次月按照乙方业务规定和双方约定结清相关费用后如有剩余的，乙方将剩余费用退还甲方。 </p>
      <p>（三）有下列情形之一的，乙方有权单方解除协议，收回号码或账号并终止服务，并保留追究甲方违约责任的权利： </p>
      <p>1、甲方提供的有效证件（包括代理人/经办人提供的有效身份证件）虚假、不实；  </p>
      <p>2、甲方自行安装未取得入网许可或可能影响网络安全或网络服务质量设备的； </p>
      <p>3、甲方以担保等方式取得号码使用权的，如担保人违反保证条款或有确切证据证明担保人无能力履行保证责任的； </p>
      <p>4、甲方未办理相关手续，自行改变电信业务使用性质或私自转让租用权的；  </p>
      <p>5、甲方欠费停机后3个月仍未交清通信费用和违约金的; </p>
      <p>6、业务（服务）超过约定有效期的； </p>
      <p>7、该号码被国家司法机关认定用于违法犯罪活动或其它不当用途的； </p>
      <p>8、乙方收到国家行政管理部门通知要求停止甲方服务的； </p>
      <p>9、预付费产品在约定期限内未激活的； </p>
      <p>10、违规外呼、呼叫频次异常的； </p>
      <p>11、法律法规规定的其他情形。 </p>
      <p>（四）因技术进步或国家政策等原因导致本协议（部分或全部）无法继续履行的，乙方保留对电信业务（服务）做出调整的权利，调整前乙方应按照有关规定发布公告并提出相应解决方案。甲方可就解决方案与乙方协商，但不得要求乙方继续履行本协议。 </p>
        
      <p>第七条 争议解决方式 </p>
      <p>有关协议争议，双方可沟通协商解决；协商不成的，甲方可向当地通信管理局或消费者协会申请进行调解；任何一方均可向乙方住所地的人民法院起诉。 </p>
        
      <p>第八条 协议生效 </p>
      <p>本协议自甲乙双方签字盖章之日起生效，有效期一年。协议到期后，双方如无异议，有效期以一年为周期自动顺延。 </p>
      
      
      
      <p>      甲方：                                    乙方：中国联合网络通信有限公司市分公司    </p>                               
      <p>签署日期：                            签署日期：</p>
      
      
      
      
      
      
      <p>江苏联通线上订单退单处理规则公告 </p>
        
      <p>尊敬的用户： </p>
      <p>为了更好的提升中国联通APP和江苏联通网上商城线上订单处理效率，江苏联通将根据以下规则对相关订单进行退单处理： </p>
        
      <p>一、针对未支付订单的退单处理 </p>
      <p>1、号卡和宽带类订单系统默认次日晚上22点之后自动退单。 </p>
      <p>  2、手机终端类订单系统默认24小时内自动退单。 </p>
        
      <p>二、针对已支付订单的退单处理 </p>
      <p>订单处理人员会在订单处理过程中与用户进行电话联系，请用户保持电话畅通。如三天时间内五次都未能联系上用户，订单处理人员将会对订单作退单处理。 </p>
        
      <p>以上内容望悉知，江苏联通将以更强的担当责任，更优的服务质量让用户有更多的获得感。 </p>
        
                                    
      <p>中国联合网络通信有限公司江苏分公司</p>
      <p class="title">江 苏 省 公 安 厅</p>
      <p class="title">江苏省通信管理局</p>
      <p class="title">办理电话号码开户法律风险及防范提示告知书 </p>
       
      <p>为进一步加强打击治理通讯网络新型违法犯罪工作，根据《中华人民共和国刑法》、《中华人民共和国网络安全法》、《中华人民共和国电信条例》、《关于防范和打击电信网络诈骗犯罪的通告》、《工业和信息化部关于进一步防范和打击通讯信息诈骗工作的实施意见》等文件相关规定，现对办理电话号码开户人法律风险及防范提示，告知如下： </p>
      <p>一、办理固定电话、移动电话等开户入网手续，必须持本人合法有效身份证件实名登记；不得冒用他人身份证件，或者使用伪造、变造的身份证件或单位证件办理入网手续。 </p>
      <p>二、不得将办理的电话用于违法犯罪活动；不得转售、倒卖电话卡。 </p>
      <p>三、未取得电信业务经营许可证的任何组织或者个人，不得从事电信业务经营活动。 </p>
      <p>请开户申请人严格遵守以上规定，如有违反，通信运营企业将有权终止提供服务。对涉嫌伪造变造身份证件、帮助信息网络犯罪活动、非法经营等违法犯罪的，将依法严厉追究当事人法律责任。</p>
      <p>    开户申请人已清楚明确阅读上述告知内容，将依法合规申请、使用相关电信业务。 </p>
      
      <p>用户签字：                             日期： </p>
      <p>              江苏联通信息安全责任承诺书 </p>
        
      <p>一、 遵守国家有关法律、行政法规和管理规章，不实施违法使用、违规外呼、呼叫频次异常、超约定用途使用、转租转售、诈骗骚扰等行为。 </p>
      <p>二、 不利用江苏联通号卡从事外呼营销类业务，如“欠款追债”、“金融、保险、期货、理财类营销推广”、“代开发票”、“营销广告”等。 </p>
      <p>三、 用户如出现任何违反上述承诺之行为（包括但不限于被司法、行政等有权机关或行业协会、消费者协会等团体组织受理、处理、通报、处罚或被其他客户投诉），用户将自愿承担所有责任。江苏联通及有关单位有权严肃处理，包括但不限于关停机、限制通信等，用户无权要求江苏联通再次复机。 </p>
      
      
      <p>  用户签字：                  签署日期：</p>
    </div>
    <!-- 《中国联通客户移动业务靓号协议》 -->
    <div class="agreement-wrapper" v-if="type === 4">
      <p class="title">中国联通客户移动业务靓号协议 </p>
      <p>甲方：                                                           (以下简称“甲方”) </p>
      <p>乙方：中国联合网络通信有限公司           市分公司    (以下简称“乙方”) </p>
      
      <p>本协议作为《中国联通客户入网服务协议》的补充协议，并与《中国联合网络通信有限公司        市分公司综合业务受理单》（以下简称业务受理单）合并使用。甲乙双方在平等自愿、公平诚信的基础上，基于对乙方移动通信服务的了解和需求，达成协议如下： </p>
      <p>第一条 甲方所选择的移动业务靓号及相关的预存款、月承诺通信费、协议期及套餐等内容详见业务受理单，业务受理单作为本协议的重要组成部分，具有与本协议同等的效力。 </p>
      <p>第二条 使用条件 </p>
      <p>(一)    本协议中甲方预存款在开户当日返至用户话费账户，仅限该靓号使用，可延期消费，只在甲方办理过户或销户业务时方可退还余额部分。预存款可用于抵扣甲方月承诺通信费（含语音、短信、数据、国际长途、国际漫游等费用，不含CP/SP等代收费项目）。 </p>
      <p>当甲方月承诺靓号通信费与其选择的营销活动套餐月消费金额有差异时，每月两者比较取高值。 </p>
      <p>(二)    在本协议期内，甲方不能办理降低月承诺通信费、销户、停机保号、携号转网等业务。 </p>
      <p>  (三)    本协议期内或协议期外，甲方办理过户业务时，新用户均应按照乙方当前靓号规则，重新签订靓号协议且重新匹配预存款、月承诺通信费、协议期。 </p>
      <p>  (四)    若甲方为乙方现有2G或3G用户，在申请办理迁转4G或5G业务时，甲乙双方所签原协议中的剩余预存款、月承诺通信费、剩余协议期仍按原协议执行，但过户、销户等规则应按照本协议执行。 </p>
      <p>  (五)    本协议期满后，甲方可继续使用移动靓号，同时不受乙方规定的靓号办理条件限定。乙方另有约定的除外。 </p>
      <p>  (六)    甲方承诺自办理之日至协议期满靓号正常开通使用，并履行以上使用条件；若靓号欠费至90天且未缴费停机的，按照《中华人民共和国电信条例》的相关规定，乙方有权追缴欠费并停止服务、回收该靓号，同时本文约定自动解除。 </p>
      <p>  （七）号码        ，靓号预存       元，协议期         }个月，月承诺消费        }元，靓号预存大写  </p>          
      <p>  （八）   以下类型的靓号订单仅支持省内上门交付，江苏省外地址不配送。靓号类型如下∶AAAAAAAA(8连号)、AAAABBBB(A≠4且B≠4)、AAAAAAA(7连号)、AAAAAA(6连号)、AAAABBBB(B=4)、AAAAA(5连号)、AABBCCDD(累加/递减)、ABCDEF、ABABABAB(A≠4且B≠4)、FEDCBA、ABCDABCD、AAAA(A≠4)、AAABBB(A≠4且B≠4)、ABCDE、EDCBA、AAAA(A=4)、AAAAB(A≠4且B≠4)、AAA(A≠4)、ABABAB(A≠4且B≠4)、ABCD、AABBCC(A≠4且B≠4且C≠4)、DCBA、AAABBB(B≠4)。 </p>
      <p>第三条 违约责任及承担 </p>
      <p>（一）甲方违约责任 </p>
      <p>    1.   甲方在协议期内发生销户等行为时，则甲方构成违约，应向乙方支付靓号违约金（靓号违约金=剩余协议期月数*月承诺通信费*95%）。 </p>
      <p>    2.   乙方有权以甲方账户中剩余的预存款直接抵扣欠费、违约金及约定的相关费用，不足部分，乙方保留对甲方追缴的权利。违约金包括但不限于：因甲方欠费发生的逾期付款违约金等。 </p>
      <p>（二）乙方违约责任 </p>
      
      <p>乙方构成违约的，应按《中华人民共和国电信条例》及其他有关规定，承担违约责任。 </p>
      <p>第四条 协议生效 </p>
      <p>本协议自双方签字或盖章之日起生效，本协议到期时，如甲乙双方均未提出对套餐资费的修改要求，将继续执行本协议约定的套餐资费。</p> 
      
      <p>（甲方承诺：本人已经充分、完整阅读并理解本协议所述全部条款及条件。） </p>
      
       
      <p>甲方：                                                乙方：中国联合网络通信有限公司               市分公司 </p>
      <p>业务号码：  </p>
      <p>签署日期：                                  签署日期：    </p> 
    </div>
    <!-- 《中国联通用户隐私政策》 -->
    <div class="agreement-wrapper" v-if="type === 5">
      <p class="title">中国联通用户隐私政策</p>
      <p>中国联通（以下简称“我们”）非常重视用户的隐私和个人信息保护，致力于维持您对我们的信任。我们承诺采取相应的安全保护措施来保护您的个人信息。请在使用我们的移动业务、宽带业务、固话业务、融合业务、IDC服务、ICT服务、云计算服务、大数据服务、物联网服务等各项产品或服务（以下统称“我们的产品或服务”）前，仔细阅读并了解《中国联通用户隐私政策》（以下简称“本隐私政策”）。 </p>
      <p>您在使用我们的产品或服务时，我们将按照《中华人民共和国个人信息保护法》等国家法律法规及监管政策的相关要求处理您的个人信息，以及向您提供服务，我们希望通过本隐私政策向您说明：在您使用我们的产品或服务时，我们会收集哪些数据、为什么收集这些数据、会利用这些数据做什么以及我们如何保护这些数据。 </p>
      <p>本隐私政策与您所使用的我们的产品或服务息息相关，对于您行使个人权利及保护您的个人信息至关重要，请您在使用我们的产品或服务前认真阅读并充分理解本隐私政策所写明的内容。 </p>
      <p>阅读过程中，如您对我们的隐私政策及服务条款的内容有任何疑问，请联系我们。如您签署或点击确认本隐私政策，即表示您已经理解并同意本隐私政策全部内容。本隐私政策包含以下内容： </p>
      <p>我们如何收集和使用您的个人信息； </p>
      <p>我们如何使用 Cookie 和同类技术； </p>
      <p>我们如何共享、转移、公开披露您的个人信息；</p> 
      <p>我们如何保护您的个人信息； </p>
      <p>我们如何处理未成年人的个人信息； </p>
      <p>您的个人信息如何存储及在全球范围转移； </p>
      <p>本隐私政策如何更新； </p>
      <p>您的权利； </p>
      <p>如何联系我们。 </p>
      <p>一、我们如何收集和使用您的个人信息 </p>
      <p>个人信息是指以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。 </p>
      <p>（一）为更好地为您提供服务，中国联通将遵循“合法、正当、必要和诚信”原则，按照相关法律法规及监管政策的规定收集和使用如下您的个人信息： </p>
      <p>1.用户登记的个人身份信息 </p>
      <p>根据《中华人民共和国网络安全法》《电话用户真实身份信息登记规定》（工业和信息化部令第25号）等规定，您在办理入网手续时须向我们出示有效证件、提供真实身份信息；同时，为了验证该类信息的准确性和完整性，我们会将您提供的信息与合法存有您信息的机构（政府机关、事业单位、商业机构）进行验证核对；通过核验后，我们将通过识别仪、高拍仪、纸质/电子表单等方式对您的个人身份信息进行登记，通过拍照或在线视频留存您的个人信息、办理入网手续。留存的个人信息主要包括：个人身份及网络身份标识鉴权信息[主要包括个人用户姓名、有效通信联系方式、有效证件类型及号码、证件登记信息、装机地址、交费账号、电子邮箱、拍照或在线视频方式获得的影像资料、服务账号及密码、密码保护答案、办理的业务]。如您拒绝提供个人有效证件及真实信息，将无法办理入网手续，无法使用我们的产品或服务。 </p>
      <p>2、使用服务过程中产生的信息 </p>
      <p>您使用我们提供的服务时，我们可能自动收集以下信息： </p>
      <p>（1）日志信息 </p>
      <p>指您使用我们服务时，系统可能通过 cookies、web beacon 或其他方式自动采集的技术信息，包括： </p>
      <p>A.设备或软件信息，例如您的移动设备、网页浏览器或您用于接入我们的服务的其他程序所提供的配置信息、您的IP地址和您的移动设备所用的版本和设备识别码。 </p>
      <p>B.您在使用我们服务时搜索和浏览的信息，例如您使用的搜索关键字、访问页面，以及您在使用我们服务时浏览或要求提供的其他信息。 </p>
      <p>C．实现服务所必须的基本信息，例如为实现接通您的通话网络所必需的对方号码。 </p>
      <p>（2）位置信息 </p>
      <p>指您开启设备定位功能或使用我们基于位置提供的相关服务时，我们收集的有关您位置的信息，例如您通过具有定位功能的移动设备使用我们的服务时，我们通过IP地址、GPS、基站、Wi-Fi等方式收集的您的地理位置信息。 </p>
      <p>（3）订购信息 </p>
      <p>指您通过中国联通营业厅、http://www.10010.com网上营业厅、中国联通短信营业厅、中国联通APP、中国联通授权的代理渠道等正规渠道订购移动通信、宽带接入及其他增值服务或购买商品时产生的记录，如订购关系记录、消费记录等。 </p>
      <p>（4）手机账户信息 </p>
      <p>指您手机登录账户的信息，例如在您选择使用手机账号登录我们的服务时，我们会获取您的手机账号等相关信息。 </p>
      <p>3.为共同向您提供产品服务或改进产品服务的质量或出于对产品服务安全性的考量等合理需要，我们可能按照相关法律法规及监管政策的要求或经过您的授权从关联公司、合作伙伴及其他受信任的第三方接收您的个人信息及其他信息。例如当您通过我们关联公司、业务合作伙伴网站订购我们的产品，您向其提供的预订信息可能会转交给我们，以便我们处理您的订单。 </p>
      <p>4.在收集过程中，我们将严格遵守相关法律法规及监管政策，不收集任何法律法规及监管政策禁止收集的信息。 </p>
      <p>5.您了解并同意，以下情形中我们使用个人信息无需征得您的授权同意： </p>
      <p>（1）为订立、履行与您的合同所必需； </p>
      <p>（2）为履行法定职责或者法定义务所必需； </p>
      <p>（3）为应对突发公共卫生事件，或者紧急情况下为保护您的生命健康和财产安全所必需； </p>
      <p>（4）在合理的范围内处理您自行公开或者其他已经合法公开的个人信息； </p>
      <p>（5）与国家安全、国防安全有关的； </p>
      <p>（6）与公共安全、重大公共利益有关的； </p>
      <p>（7）与犯罪侦查、起诉、审判和判决执行等有关的； </p>
      <p>（8）用于维护所提供的产品或服务的安全稳定运行所必需，例如发现、处置产品或服务的故障； </p>
      <p>（9）法律法规及监管政策规定的其他情形。 </p>
      <p>（二）为向您提供服务，在遵守国家法律法规及监管政策的前提下，我们可能将收集到的您的个人信息用于以下目的： </p>
      <p>1.为您提供服务 </p>
      <p>（1）在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性； </p>
      <p>（2）根据国家相关要求，用于旨在推进政府管理、加强社会治理、改善社会民生、建立诚信体系等目的的服务；</p> 
      <p>（3）使我们更加了解您如何使用我们的服务，从而针对性地满足您的个人需求，例如语言设定、位置设定、个性化的帮助服务和指示，或对您和其他使用我们服务的用户做出其他方面的回应； </p>
      <p>（4）用于向您提供个性化或定制化产品、服务或广告，如您不希望收到这些信息，可通过订购渠道、前往中国联通当地营业厅、拨打10010客服热线等方式中的一种或几种取消订购或订阅。 </p>
      <p>（5）通过信息数据分析，帮助我们设计并为您提供更好感知的新服务；如您不希望收到这些信息，可通过订购渠道、前往中国联通当地营业厅、拨打10010客服热线等方式中的一种或几种取消订购。 </p>
      <p>（6）评估我们的服务效果，并加以改善； </p>
      <p>（7）软件认证或管理软件升级； </p>
      <p>（8）邀请您参与有关我们产品和服务的调查。 </p>
      <p>2.您了解并同意，我们可以通过技术手段对您的个人信息数据进行匿名化处理，匿名化处理的信息将无法识别个人主体。在此情况下我们有权使用已经匿名化的信息，并在符合相关法律法规及监管政策的前提下，我们有权对包括您的个人信息在内的用户数据库进行整体化分析和利用。</p> 
      <p>3.当我们要将信息用于本隐私政策未载明的其它用途时，会事先征求您的同意。 </p>
      <p>二、我们如何使用 Cookie 和同类技术 </p>
      <p>（一）Cookie </p>
      <p>为确保网站正常运转，我们会在您的计算机或移动设备上存储名为 Cookie的小数据文件。Cookie通常包含标识符、站点名称以及一些号码和字符。借助于Cookie，网站能够存储您的偏好或购物篮内的商品等数据。</p> 
      <p>我们不会将Cookie用于本隐私政策所述目的之外的任何用途。您可根据自己的偏好管理或删除Cookie。有关详情，请参见AboutCookies.org。您可以清除计算机上保存的所有Cookie，大部分网络浏览器都设有阻止Cookie的功能。但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置。 </p>
      <p>（二）网站信标和像素标签 </p>
      <p>除Cookie外，我们还有可能会在网站上使用网站信标和像素标签等其他同类技术。例如，我们向您发送的电子邮件可能含有链接至我们网站内容的点击 URL。如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好并改善客户服务。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订。 </p>
      <p>（三）Do Not Track（请勿追踪） </p>
      <p>很多网络浏览器均设有“Do Not Track”（请勿追踪）功能，该功能可向网站发布“Do Not Track”请求。目前，主要互联网标准组织尚未设立相关政策来规定网站应如何应对此类请求。但如果您的浏览器启用了“Do Not Track”，那么我们的所有网站都会尊重您的选择。 </p>
      <p>三、我们如何共享、转移和公开披露个人信息 </p>
      <p>（一）共享 </p>
      <p>我们不会与中国联通以外的任何公司、组织和个人分享您的个人信息，但以下情况除外： </p>
      <p>1.在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。 </p>
      <p>2.我们可能会根据法律法规及监管政策要求，或按政府主管部门的强制性要求，对外共享您的个人信息。 </p>
      <p>3.您授权银行、证券、保险、征信机构等第三方向我们查询、收集您在中国联通的信息，或者我们会在法律法规及监管政策允许范围内及您对第三方的授权范围内向第三方共享您的信息，我们会依据与第三方的约定、对个人信息来源的合法性进行确认后，在符合法律法规及监管政策的前提下，使用您的这些个人信息。 </p>
      <p>4.与我们的关联公司共享：您的个人信息可能会与我们的关联公司共享。我们将依照合法、正当、必要、诚信原则，仅出于在能够实现业务目的最小范围内共享您必要的个人信息，且受本隐私政策所声明目的的约束。如相关法律法规、监管政策要求或我们为维护您的权益认为确有必要时，我们亦会在将信息提供给关联公司前征得您的单独同意。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。 </p>
      <p>我们的关联公司包括中国联通现在或将来控制、受控制或与其处于共同控制下的任何公司、机构以及上述公司或机构的合法继承人。其中“控制”是指直接或间接地拥有影响所提及公司管理的能力，无论是通过所有权、有投票权的股份、合同或其他被人民法院认定的方式。 </p>
      <p>5.与授权合作伙伴共享：仅为实现本隐私政策中声明的目的，我们的某些服务将由授权合作伙伴提供，为此我们可能会与合作伙伴共享您的某些个人信息。例如，在您通过我们的网站购买商品或订购业务时，我们必须与物流服务提供商共享您的个人信息才能安排送货，或者安排合作伙伴提供服务。我们将依照合法、正当、必要、诚信原则，仅出于在能够实现业务目的最小范围内共享您必要的个人信息。如相关法律法规、监管政策要求或我们为维护您的权益认为确有必要时，我们亦会在将信息提供给授权合作伙伴前征得您的单独同意。我们的合作伙伴无权将共享的个人信息用于任何其他用途。 </p>
      <p>目前，我们的授权合作伙伴包括以下3大类型： </p>
      <p>（1）供应商、服务提供商和其他合作伙伴。我们将信息发送给支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括提供技术基础设施服务、分析我们服务的使用方式、衡量广告和服务的有效性、提供客户服务、支付便利、交易安全服务或进行学术研究和调查。 </p>
      <p>（2）第三方商家。我们必须将您的订单信息与交易有关的必要信息与第三方商家共享来实现您向其购买商品或服务的需求，并促使其可以完成后续的售后服务。 </p>
      <p>（3）广告、分析服务类的授权合作伙伴。除非得到您的许可，否则我们不会共享用于识别您个人身份的信息，我们可能会将使用您的信息而形成的用户画像与提供广告、分析服务的合作伙伴共享，以提升广告及服务信息的有效触达率。对我们与之共享个人信息的公司、组织和个人，我们会与其签署相应的保密协定，要求他们按照我们的说明、隐私政策以及其他任何相关的保密和安全措施来处理个人信息。</p> 
      <p>（二）转移 </p>
      <p>我们不会将您的个人信息转移给任何公司、组织和个人，但以下情况除外： </p>
      <p>1.在获取明确同意的情况下转移：获得您的明确同意后，我们会向其他方转移您的个人信息； </p>
      <p>2.在涉及合并、收购或破产清算时，如涉及到个人信息转移，我们会要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意； </p>
      <p>3. 相关法律法规规定或我们与您约定的其他情形。 </p>
      <p>（三）公开披露 </p>
      <p>我们仅会在以下情况下，公开披露您的个人信息： </p>
      <p>1.获得您明确同意后； </p>
      <p>2.基于法律的披露：在法律法规、法律程序或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。 </p>
      <p>四、我们如何保护您的个人信息 </p>
      <p>（一）我们承诺将严格按照国家有关规定做好用户个人信息安全防护工作。我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们将采取一切合理可行的措施，（例如身份鉴别、信息收集监测和审计、网络专线传输、防入侵、防病毒、信息加密存储、信息访问的权限管理、信息认证授权和监控审计、信息脱敏、信息溯源等）以及配套的管理体系来保护您的个人信息。同时我们已设立用户信息保护责任部门，建立相关内控制度，对可能接触到您信息的工作人员采取最小够用授权原则；对工作人员进行相关法律法规、隐私政策和安全意识培训，对工作人员处理您的信息的行为进行系统监控。我们并将接受国家相关机构的信息安全检查。 </p>
      <p>（二）您需要承诺妥善保存登录的账号、密码等信息，由于您的原因造成账号密码的泄露产生的后果由您承担。为防止信息泄露，我们将采取防泄漏、反爬虫等技术手段，限制频繁查询您的信息等异常操作行为，以防止账号密码泄露或他人冒用身份造成您产生不良行为记录或者您的信息泄露。 </p>
      <p>    （三）我们已制定个人信息安全事件应急预案，提高应急处理能力。但由于技术水平限制及可能存在的各种恶意手段，有可能因我们可控范围外的因素而出现安全问题。在发生个人信息安全事件后，我们将按照相关法律法规及监管政策的要求，及时向您告知：安全事件的基本情况和可能影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。 </p>
      <p>五、我们如何处理未成年人的个人信息 </p>
      <p>（一）我们非常重视对未成年人个人信息的保护。我们将根据国家相关法律法规及监管政策的规定保护未成年人的个人信息。 </p>
      <p>（二）如您为不满十四周岁的未成年人，在使用我们的服务前，应在您的父母或其他监护人监护、指导下共同阅读本隐私政策，并由您的父母或其他监护人确认是否同意本隐私政策。 </p>
      <p>（三）对于经父母或其他监护人同意而收集未成年人个人信息的情况，我们只会在受到法律允许、父母或其他监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。 </p>
      <p>（四）如您是未成年人的父母或其他监护人，请您关注您监护的未成年人是否在取得您的授权同意之后使用我们的服务。如您对您所监护的未成年人的个人信息有疑问，请通过本隐私政策中的联系方式与我们联系。 </p>
      <p>（五）如果我们发现自己在未事先获得可证实的父母或其他监护人同意的情况下收集了未成年人的个人信息，会设法尽快删除相关数据。 </p>
      <p>（六）我们制定了专门的未成年人个人信息处理规则，您可以通过阅读《中国联通儿童个人信息保护政策及监护人须知》了解更多信息。 </p>
      <p>六、您的个人信息如何存储及在全球范围转移 </p>
      <p>我们在中华人民共和国境内收集的个人信息，将存储在中华人民共和国境内。我们仅在本隐私政策所述目的所必需期间和法律法规及监管规定的时限内保留您的个人信息。如果需要将您的个人信息转移到境外，我们将： </p>
      <p>（一）另行获得您的授权同意，并履行法定程序，在符合届时适用法律的情形下使您的个人信息得到足够的保护； </p>
      <p>（二）该等转移将在符合届时适用法律要求的前提下进行，即便获得您的授权但如果转移方式或者目的不符合相关法律法规规定的，我们也不会进行转移。 </p>
      <p>七、本隐私政策如何更新 </p>
      <p>我们的隐私政策可能变更。未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。基于为给您提供更好的服务以及随着电信业务的发展或法律法规及监管政策变化，我们可能会适时对本隐私政策进行更新。由于我们的用户较多，如本隐私政策发生重大变更，我们将以推送通知、发送邮件、信函、电话或者在中国联通APP、中国联通官方网站发布公告的方式来通知您。若您在本隐私政策修订后继续使用我们的产品或服务，这表示您已充分阅读、理解并愿意接受修订后的本隐私政策约束。 </p>
      <p>八、您的权利 </p>
      <p>（一）访问您的个人信息 </p>
      <p>您有权访问您的个人信息，法律法规规定的例外情形除外。您可前往中国联通当地营业厅、拨打10010客服热线、访问http://www.10010.com网上营业厅、使用中国联通APP等多种方式，查询您的个人信息或修改您的个人资料。 </p>
      <p>（二）更正您的个人信息</p>
      <p>当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正。您可以通过“（一）访问您的个人信息”中罗列的方式提出更正申请。 </p>
      <p>（三）删除您的个人信息 </p>
      <p>在以下情形中，您可以前往中国联通当地营业厅向我们提出删除个人信息的请求： </p>
      <p>1.如果我们处理个人信息的行为违反法律法规； </p>
      <p>2.如果我们收集、使用您的个人信息，却未征得您的同意； </p>
      <p>3.如果我们处理个人信息的行为违反了与您的约定； </p>
      <p>4.如果您不再使用我们的产品或服务，或您注销了账号； </p>
      <p>5.如果我们不再为您提供产品或服务。 </p>
      <p>请您注意，当您或我们协助您成功删除相关信息后，因为适用的法律和安全技术限制，我们可能无法立即从备份系统中删除相应的信息，之前的信息我们仍会按照监管政策要求的时间进行保存，且在该依法保存的时间内有权机关仍有权依法查询，保存期间我们会安全地存储您的个人信息并限制对其的任何进一步的处理，直到备份可以删除或实现匿名化。 </p>
      <p>（四）改变您授权同意的范围 </p>
      <p>每个业务功能需要一些基本的个人信息才能得以完成。对于额外收集的个人信息的收集和使用，您可以随时给予或收回您的授权同意。您可以前往中国联通当地营业厅、访问http://www.10010.com网上营业厅、使用中国联通APP等多种方式设置（如历史记录设置等）来关闭部分功能选项从而撤销部分授权。当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也将不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的同意或授权而开展的个人信息处理活动的效力。 </p>
      <p>（五）响应您的上述请求 </p>
      <p>为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的要求。对于您关于用户个人信息的合理请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。在以下情形中，按照法律法规及监管政策要求，我们将无法响应您的请求： </p>
      <p>1.与国家安全、国防安全直接相关的； </p>
      <p>2.与公共安全、公共卫生、重大公共利益直接相关的； </p>
      <p>3.与犯罪侦查、起诉、审判和判决执行等直接相关的； </p>
      <p>4.有充分证据表明您存在主观恶意或滥用权利的； </p>
      <p>5.响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</p> 
      <p>6.涉及商业秘密的。 </p>
      <p>九、如何联系我们 </p>
      <p>公司名称：中国联合网络通信有限公司 </p>
      <p>注册地址：北京市西城区金融大街21号联通大厦 </p>
      <p>联系电话：10010客服热线 </p>
      <p>相关负责人邮箱：hqs-yhys@chinaunicom.cn </p>
      <p>网站：http://www.10010.com </p>
      <p>如您对本隐私政策或您个人信息的相关事宜有任何问题、投诉、意见或建议，您可前往中国联通当地营业厅、拨打10010客服热线、访问http://www.10010.com网上营业厅、使用中国联通APP等多种方式与我们联系。一般情况下，我们将在十五个工作日内回复。 </p>
        
      <p>本版发布日期：2022年1月15日 </p>
      <p>生效日期：2022年1月15日 </p>
      <p>甲方：</p>
      <p>乙方：中国联合网络通信有限公司_____分公司 </p>
      <p>签署日期：        </p>
    </div>
  </van-popup>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      type: '',
    };
  },
  methods: {
    show(type) {
      console.log('type', type);
      this.type = type;
      this.visible = true;
    },
  },
};
</script>

<style lang="less" scoped>
.agreement-wrapper {
  height: 300px;
  overflow: scroll;
  background-color: #fff;
  text-indent: 28px;
  line-height: 25px;
  padding: 10px 10px;
  text-align: justify;
  p {
    font-size: 12px;
  }
  .title {
    text-indent: 0;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    margin: 20px 0;
  }
}
</style>
